module.exports = __webpack_public_path__ + "img/55ne.6a20fe7e.svg";